import { Children as o, isValidElement as r } from "react";
const l = (e) => e.key || "";
function f(e) {
  const t = [];
  return o.forEach(e, (n) => {
    r(n) && t.push(n);
  }), t;
}
export {
  l as getChildKey,
  f as onlyElements
};
